module.exports = __webpack_public_path__ + "img/icon_1_44.e6d160ad.png";